var Layred = (function () {
  var handleTextChar = function () {
    var wordRoateElements = document.querySelectorAll('.word-rotate');
    wordRoateElements.forEach((data, _) => {
      var wordRoate = $(data).text().split('');
      const step = 360 / wordRoate.length;
      wordRoate.forEach((el, i) => {
        $(data)
          .closest('.word-rotate-box')
          .append('<span class="text__char" style="--char-rotate :' + i * step + 'deg">' + el + '</span>');
      });
      $(data).remove();
    });
  };

  var handleLightGallery = function () {
    if (jQuery('#lightgallery').length > 0) {
      lightGallery(document.getElementById('lightgallery'), {
        plugins: [lgThumbnail, lgZoom, lgVideo],
        selector: '.lg-item',
        thumbnail: true,
        exThumbImage: 'data-src',
      });
    }
  };
  

  var handleShowPassword = function () {
    $('.dz-search-password .show-pass').on('click', function () {
      $(this).parent().toggleClass('show');
      if ($(this).parent().hasClass('show')) {
        $(this).parent().find('input').attr('type', 'text');
      } else {
        $(this).parent().find('input').attr('type', 'password');
      }
    });
  };

  var handleResizeElement = function () {
		var headerTop = 0;
		var headerNav = 0;

		$('.header .sticky-header').removeClass('is-fixed');
		$('.header').removeAttr('style');

		if (jQuery('.header .top-bar').length > 0 && screenWidth > 991) {
			headerTop = parseInt($('.header .top-bar').outerHeight());
		}

		if (jQuery('.header').length > 0) {
			headerNav = parseInt($('.header').height());
			headerNav = (headerNav == 0) ? parseInt($('.header .main-bar').outerHeight()) : headerNav;
		}

		var headerHeight = headerNav + headerTop;

		jQuery('.header').css('height', headerHeight);
	}

  var headerFix = function () {
		/* Main navigation fixed on top  when scroll down function custom */
		jQuery(window).on('scroll', function () {
			if (jQuery('.sticky-header').length > 0) {
				var menu = jQuery('.sticky-header');
				if ($(window).scrollTop() > menu.offset().top) {
					menu.addClass('is-fixed');
				} else {
					menu.removeClass('is-fixed');
				}
			}
		});
		/* Main navigation fixed on top  when scroll down function custom end*/
	}


  /* Function ============ */
  return {
    init: function () {
      handleTextChar();
      handleLightGallery();
      handleShowPassword();
      headerFix();
    },

    load: function () {
      handleResizeElement();
    },

    scroll: function () {},

    resize: function () {
      handleResizeElement();
    },
  };
})();

/* Document.ready Start */
jQuery(document).ready(function () {
  'use strict';
  Layred.init();
});
/* Document.ready END */

/* Window Load START */
jQuery(window).on('load', function () {
  'use strict';
  Layred.load();
});
/*  Window Load END */

/* Window Resize START */
jQuery(window).on('resize', function () {
  'use strict';
  Layred.resize();
});
/*  Window Resize END */

/* Window scroll START */
jQuery(window).on('scroll', function () {
  'use strict';
  Layred.scroll();
});
/*  Window scroll END */
